// @flow
/** @jsx jsx */

import * as React from 'react';

import {
  border,
  borderRadius,
} from '@zapier/common-components/src/components/Tabs/constants';
import { css, jsx } from '@emotion/core';

type TabListProps = {
  /** Array of TabTitle Components */
  children?: React.Node,
};

const tabListCss = css({
  alignItems: 'flex-start',
  border,
  borderBottom: 'none',
  borderTopLeftRadius: borderRadius,
  borderTopRightRadius: borderRadius,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflow: 'hidden',
});

/**
 * For use inside of the `Tabs` component
 */
const TabList = ({ children }: TabListProps) => {
  return (
    <div css={tabListCss} role="tablist">
      {children}
    </div>
  );
};

export default TabList;
